import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import IconButton from '@material-ui/core/IconButton'
import * as actions from '../actions'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { Dialog } from '@material-ui/core'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import HistoryIcon from '@material-ui/icons/History'
import StorageIcon from '@material-ui/icons/Storage'
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore'
import FindInPageIcon from '@material-ui/icons/FindInPage'
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat'
import Fade from '@material-ui/core/Fade'

import DialogoComunicacionUpdate from '../components/DialogoComunicacionUpdate'
import DialogoCOEMsView from '../components/DialogoCOEMsView'
import DialogoComunicacionHistorial from '../components/DialogoComunicacionHistorial'
import { FORM_LISTADO_COEMS } from '../../../config/forms'

function EdicionCaratulaFinalizada (props) {
  const {
    id,
    closeModal,
    resetCaratulaExportador
  } = props

  const [open, setOpen] = useState(false)

  const [openHistory, setOpenHistory] = useState(false)

  const [openCoems, setOpenCoems] = useState(false)

  const handleOpen = () => setOpen(true)

  const handleOpenHistory = () => {
    handleCloseMenu()
    setOpenHistory(true)
  }

  const handleCloseHistory = () => {
    resetCaratulaExportador()
    setOpenHistory(false)
  }

  const handleClose = () => {
    resetCaratulaExportador()
    setOpen(false)
  }

  const eliminarCode = (id) => {
    const result = window.confirm('¿Desea regresar la Carátula al estado ACTIVA?')
    if (result) props.eliminarCode(id)
    handleCloseMenu()
  }

  const consultaEstadosCoem = (id) => {
    const result = window.confirm('¿Desea consultar estados de COEMs en Aduana?')
    handleCloseMenu()
    if (result) props.consultaEstadosCoem(id)
  }

  const consultaSolicitudes = (id) => {
    const result = window.confirm('¿Desea consultar el estado de las Solicitudes en Aduana?')
    handleCloseMenu()
    if (result) props.consultaSolicitudes(id)
  }

  const consultaNoAbordo = (id) => {
    const result = window.confirm('¿Desea consultar solicitudes de No a bordo en Aduana?')
    handleCloseMenu()
    if (result) props.consultaNoAbordo(id)
  }

  const handleOpenCoems = () => setOpenCoems(true)

  const handleCloseCoems = () => {
    closeModal()
    resetCaratulaExportador()
    setOpenCoems(false)
  }

  function onClickCoems () {
    handleCloseMenu()
    handleOpenCoems()
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open1 = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleClickAway = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <div>
        <Dialog
          open={openHistory}
          onClose={handleCloseHistory}
          fullWidth
          maxWidth='lg'>
          <DialogoComunicacionHistorial id={id} handleClose={handleCloseHistory} />
        </Dialog>
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth='md'>
          <DialogoComunicacionUpdate id={id} onlyView handleClose={handleClose} handleSubmit={() => null} />
        </Dialog>
        <Dialog
          open={openCoems}
          onClose={handleCloseCoems}
          fullWidth
          maxWidth='lg'>
          <DialogoCOEMsView id={id} onlyView handleClose={handleCloseCoems} handleSubmit={() => null} />
        </Dialog>
        <ClickAwayListener onClickAway={() => handleClickAway()}>
          <div>
            <IconButton aria-controls='fade-menu' aria-haspopup='true' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id='fade-menu'
              anchorEl={anchorEl}
              keepMounted
              open={open1}
              onClose={handleCloseMenu}
              TransitionComponent={Fade}
            >
              <MenuItem onClick={onClickCoems}><StorageIcon fontSize='small' color='action' />&nbsp;COEMs asociados...</MenuItem>
              <MenuItem onClick={() => handleOpen()}><DirectionsBoatIcon fontSize='small' color='action' />&nbsp;Carátula</MenuItem>
              <MenuItem onClick={() => consultaEstadosCoem(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar Estado de COEMs</MenuItem>
              <MenuItem onClick={() => consultaNoAbordo(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar No a Bordo</MenuItem>
              <MenuItem onClick={() => consultaSolicitudes(id)}><FindInPageIcon fontSize='small' color='action' />&nbsp;Consultar Solicitudes</MenuItem>
              <MenuItem onClick={() => eliminarCode(id)}><SettingsBackupRestoreIcon fontSize='small' color='action' />&nbsp;Regresar al estado Activa</MenuItem>
              <MenuItem onClick={() => handleOpenHistory()}><HistoryIcon fontSize='small' color='action' />&nbsp;Historial</MenuItem>
            </Menu>
          </div>
        </ClickAwayListener>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_LISTADO_COEMS,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(EdicionCaratulaFinalizada))
